<div [formGroup]="editorForm">
  <ca-department-selector formControlName="editor" [filterByStatus]="config.filterByStatus">
  </ca-department-selector>
</div>
